module.exports = {
   api : process.env.REACT_APP_API_URL,
 // api : 'http://172.17.104.210:8000/api',
  // api : 'http://172.17.104.210:8000/api',
  // api : 'http://localhost:4000/api',
  footerNotice: "Copyright © KocharTech " + new Date().getFullYear(),
  SUPERSET_URL: process.env.REACT_APP_SUPERSET_URL,
  DASHBOARD_IDS: [
    {
      label: "Admin Dashboard",
      key: process.env.REACT_APP_ADMIN_DASHBOARD_ID,
       role: 'admin'
    },
    {
      label: "Recruiter Dashboard",
      key: process.env.REACT_APP_RECRUITER_DASHBOARD_ID,
       role: 'interviewer'
    },
    // {
    //   label: "CSAT",
    //   key: process.env.REACT_APP_CSAT_DASHBOARD_ID,
    // },
  ],
  environment: process.env.REACT_APP_ENVIRONMENT,
  storageType: 1, // 1 -> S3 , 0 -> Local
  officeLocations: [
    "Amritsar",
    "Amritsar Corporate",
    "Gurugram",
    "Ludhiana",
    "Gurugram",
    "Vadodara",
    "Kolkata",
  ],
  smallFileUploadSize: 5,
  largeFileUploadSize: 50,
  interviewConferenceLink: process.env.REACT_APP_INTERVIEW_CONFERENCE_LINK,
};
